import React from 'react';
import { useRefillCheckupState } from './useRefillCheckupState';
import { RefillCheckupContext } from './RefillCheckupContext';

export function RefillCheckupProvider({ children }: React.PropsWithChildren) {
  const value = useRefillCheckupState();
  return (
    <RefillCheckupContext.Provider value={value}>
      {children}
    </RefillCheckupContext.Provider>
  );
}
